<mat-horizontal-stepper [linear]="true" #stepper>
    <mat-step [stepControl]="projectFormGroup">
        <form [formGroup]="projectFormGroup">
            <ng-template matStepLabel>Project Identification</ng-template>

            <div class="grid grid-cols-12 gap-6">
                <div class="col-span-6">

                    <!-- Project Name -->
                    <mat-label>Project Name/ID<span class="red">*</span></mat-label>

                    <mat-form-field appearance="outline" class="half-width">
                        <input matInput formControlName="projectName" />
                        <mat-error *ngIf="projectFormGroup.get('projectName')?.hasError('required')">
                            Project Name is required
                        </mat-error>
                    </mat-form-field>
                </div>

                <!-- Project Type -->
                <div class="col-span-6">
                    <mat-label>Project Type<span class="red">*</span></mat-label>

                    <mat-form-field appearance="outline" class="half-width">
                        <mat-select formControlName="projectType">
                            <mat-option value="New construction">New construction</mat-option>
                            <mat-option value="Expansion">Expansion</mat-option>
                            <mat-option value="Rehabilitation">Rehabilitation</mat-option>
                        </mat-select>
                        <mat-error *ngIf="projectFormGroup.get('projectType')?.hasError('required')">
                            Project Type is required
                        </mat-error>
                    </mat-form-field>
                </div>
            </div>

            <div class="grid grid-cols-12 gap-6">
                <div class="col-span-6">
                    <!-- Location -->
                    <mat-label>Location/Geography<span class="red">*</span></mat-label>

                    <mat-form-field appearance="outline" class="half-width">
                        <input matInput formControlName="location" />
                        <mat-error *ngIf="projectFormGroup.get('location')?.hasError('required')">
                            Location is required
                        </mat-error>
                    </mat-form-field>
                </div>

                <div class="col-span-6">
                    <!-- Road Classification -->
                    <mat-label>Road Classification<span class="red">*</span></mat-label>

                    <mat-form-field appearance="outline" class="half-width">
                        <mat-select formControlName="roadClassification">
                            <mat-option value="National Highway">National Highway</mat-option>
                            <mat-option value="State Highway">State Highway</mat-option>
                            <mat-option value="District Road">District Road</mat-option>
                        </mat-select>
                        <mat-error *ngIf="projectFormGroup.get('roadClassification')?.hasError('required')">
                            Road Classification is required
                        </mat-error>
                    </mat-form-field>
                </div>


            </div>

            <div class="grid grid-cols-12 gap-6">
                <div class="col-span-6">
                    <mat-label>Project Stage<span class="red">*</span></mat-label>

                    <!-- Project Stage -->
                    <mat-form-field appearance="outline" class="half-width">
                        <mat-select formControlName="projectStage">
                            <mat-option value="Planning">Planning</mat-option>
                            <mat-option value="Design">Design</mat-option>
                            <mat-option value="Tendering">Tendering</mat-option>
                            <mat-option value="Construction">Construction</mat-option>
                            <mat-option value="Handover">Handover</mat-option>
                        </mat-select>
                        <mat-error *ngIf="projectFormGroup.get('projectStage')?.hasError('required')">
                            Project Stage is required
                        </mat-error>
                    </mat-form-field>
                </div>
                 <div class="col-span-6">
                    <mat-label>Project Owner/Authority<span class="red">*</span></mat-label>

                    <!-- Authority -->
                    <mat-form-field appearance="outline" class="half-width">
                        <input matInput formControlName="authority" />
                        <mat-error *ngIf="projectFormGroup.get('authority')?.hasError('required')">
                            Authority is required
                        </mat-error>
                    </mat-form-field>
                </div>
               
            </div>

            <div class="grid grid-cols-12 gap-6">
                 <div class="col-span-6">
                    <mat-label>Start Date<span class="red">*</span></mat-label>

                    <!-- Start Date -->
                    <mat-form-field appearance="outline" class="half-width">
                        <input matInput [matDatepicker]="startPicker" formControlName="startDate" />
                        <mat-datepicker-toggle matSuffix [for]="startPicker"></mat-datepicker-toggle>
                        <mat-datepicker #startPicker></mat-datepicker>
                        <mat-error *ngIf="projectFormGroup.get('startDate')?.hasError('required')">
                            Start Date is required
                        </mat-error>
                    </mat-form-field>
                </div>
                <div class="col-span-6">
                    <mat-label>Estimated Completion Date<span class="red">*</span></mat-label>

                    <!-- End Date -->
                    <mat-form-field appearance="outline" class="half-width">
                        <input matInput [matDatepicker]="endPicker" formControlName="endDate" />
                        <mat-datepicker-toggle matSuffix [for]="endPicker"></mat-datepicker-toggle>
                        <mat-datepicker #endPicker></mat-datepicker>
                        <mat-error *ngIf="projectFormGroup.get('endDate')?.hasError('required')">
                            Completion Date is required
                        </mat-error>
                    </mat-form-field>
                </div>
               
            </div>
            <div>
                <button mat-button matStepperNext [disabled]="!projectFormGroup.valid">Next</button>
            </div>
        </form>
    </mat-step>
</mat-horizontal-stepper>